import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import CustomSwitch from "@/shared/components/ui/Switch/CustomSwitch";

const cn = (...inputs) => twMerge(clsx(inputs));

/** A labelled on/off setting: title, explanation, optional action, and a switch. */
const ToggleField = ({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  action,
  className,
  "aria-label": ariaLabel,
}) => (
  <div
    className={cn(
      "flex items-center justify-between gap-3 rounded-xl border border-gray-100 dark:border-gray-800 px-3 py-2",
      className,
    )}
  >
    <div className="min-w-0">
      <p className="text-xs font-semibold text-gray-800 dark:text-gray-100">{label}</p>
      {description && (
        <p className="mt-0.5 text-[0.7rem] text-gray-500 dark:text-gray-400">{description}</p>
      )}
    </div>
    <div className="flex items-center gap-3 shrink-0">
      {action}
      <CustomSwitch
        size="sm"
        isChecked={checked}
        onChange={onChange}
        disabled={disabled}
        aria-label={ariaLabel || label}
      />
    </div>
  </div>
);

export default ToggleField;
